import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import image from "../../../src/assets/images/sdf.png";
import review from "../../assets/images/review.jpg";
import sizeChart from "../../assets/images/size-chart.jpg";
import { cartOperations } from "../../state/ducs/cart";
import { globalOperations } from "../../state/ducs/globalState";
import ProductCarousel from "../ProductCarousel";
import "./productDetailsMain.css";

const ProductBannerCard = (props) => {
  const navigate = useNavigate();

  const images = [
    {
      small: "",
      medium: "",
      large: `${process.env.REACT_APP_PRODUCT_IMAGE_URL}/${props.productObj.photo}`,
      full: `${process.env.REACT_APP_PRODUCT_IMAGE_URL}/${props.productObj.photo}`,
    },
  ];

  useEffect(() => {
    // Smooth scroll to top on component mount
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const addToCartHandler = () => {
    // Check if other vendor products available in the cart
    const other_vendor_products = props.cartItems.filter(
      (item) => item.vendor_name !== props.productObj.vendor_name
    );

    if (other_vendor_products.length) {
      alert("You can order single vendor product only at a time");
      return;
    }

    props.addToCart(props.productObj);
    props.showAddToCartModal();
  };

  const buyNowHandler = () => {
    // Check if other vendor products available in the cart
    const other_vendor_products = props.cartItems.filter(
      (item) => item.vendor_name !== props.productObj.vendor_name
    );

    if (other_vendor_products.length) {
      alert("You can order single vendor product only at a time");
      return;
    }

    props.addToCart(props.productObj);
    // navigate("/checkout");
    if (!props.isAuthenticated) {
      navigate('/login');
      return;
    }
    navigate("/checkout");
  };

  const goVendor = () => {
    navigate("/vendorDetails/" + props.productObj.vendor_id);
  };

  const shareOnSocialMedia = (platform) => {
    const url = window.location.href;
    const title = props.title || "Check out this product";

    let shareUrl = "";
    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;
        break;
      case "pinterest":
        shareUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&description=${encodeURIComponent(title)}`;
        break;
      default:
        break;
    }

    if (shareUrl) {
      window.open(shareUrl, "_blank", "width=600,height=400");
    }
  };

  return (
    <div>
      {/* Product Details Section */}
      <div className="container product-details-main">
        <div className="row">
          {/* Product Images */}
          <div className="col-12 col-lg-6 mb-4 mb-lg-0">
            <ProductCarousel media={images} />
          </div>

          {/* Spacer for large screens */}
          <div className="col-lg-1 d-none d-lg-block"></div>

          {/* Product Information */}
          <div className="col-12 col-lg-5">
            <h1 className="cardTitle">{props.title}</h1>

            {/* Star Rating */}
            <div className="stars">
              <i className="fa fa-star"></i>
              <i className="fa fa-star"></i>
              <i className="fa fa-star"></i>
              <i className="fa fa-star"></i>
              <i className="fa fa-star"></i>
            </div>

            {/* Price */}
            <h2 className="text-danger fw-bold my-3">{props.price}</h2>

            {/* Product Details */}
            <div className="product-info-section mb-3">
              <p><strong>Brand:</strong> {props.brand}</p>
              <p><strong>Product Code:</strong> {props.ProductCode}</p>
              <p><strong>Availability:</strong> <span className="text-success">{props.Availability}</span></p>
              <p><strong>Viewed:</strong> 10</p>
              <p><strong>Qty:</strong> {props.productObj.quantity}</p>
            </div>

            {/* Action Buttons */}
            <div className="d-flex flex-column flex-sm-row gap-2 mb-3">
              <button
                onClick={addToCartHandler}
                type="button"
                className="btn btn-danger flex-fill"
              >
                <i className="fa fa-shopping-cart me-2"></i>
                Add to Cart
              </button>
              <button
                onClick={buyNowHandler}
                type="button"
                className="btn btn-danger flex-fill"
              >
                <i className="fa fa-bolt me-2"></i>
                Buy Now
              </button>
            </div>

            {/* Vendor Info */}
            <h6
              className="vendor-link mb-3"
              onClick={goVendor}
            >
              <i className="fa fa-store me-2"></i>
              Shop Name: {props.productObj.vendor_name}
            </h6>

            {/* Social Share */}
            <div className="social-share-section">
              <h6 className="mb-2">Share This</h6>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <i
                  className="fa fa-facebook-square social-icon"
                  onClick={() => shareOnSocialMedia("facebook")}
                  style={{
                    fontSize: "36px",
                    color: "#1877F2",
                    cursor: "pointer",
                  }}
                  title="Share on Facebook"
                ></i>
                <i
                  className="fa fa-twitter social-icon"
                  onClick={() => shareOnSocialMedia("twitter")}
                  style={{
                    fontSize: "36px",
                    color: "#1D9BF0",
                    cursor: "pointer",
                  }}
                  title="Share on Twitter"
                ></i>
                <i
                  className="fa fa-pinterest social-icon"
                  onClick={() => shareOnSocialMedia("pinterest")}
                  style={{
                    fontSize: "36px",
                    color: "#B7081B",
                    cursor: "pointer",
                  }}
                  title="Share on Pinterest"
                ></i>
                <i
                  className="fa fa-instagram social-icon"
                  style={{
                    fontSize: "36px",
                    color: "#FE205A",
                    cursor: "pointer",
                  }}
                  title="Share on Instagram"
                ></i>
              </div>
            </div>

            {/* Additional Image */}
            <img className="mt-3 img-fluid" src={image} alt="Additional product info" />
          </div>
        </div>
      </div>

      {/* Product Details Tabs Section */}
      <div className="container py-4 py-md-5">
        <div className="row">
          <div className="col-12 col-lg-10 col-xl-8">
            <nav>
              <div className="nav nav-tabs customTabs" id="nav-tab" role="tablist">
                <button
                  className="nav-link active"
                  id="nav-home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-home"
                  type="button"
                  role="tab"
                  aria-controls="nav-home"
                  aria-selected="true"
                >
                  Description
                </button>
                <button
                  className="nav-link"
                  id="nav-profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-profile"
                  type="button"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false"
                >
                  Reviews (0)
                </button>
                <button
                  className="nav-link"
                  id="nav-contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-contact"
                  type="button"
                  role="tab"
                  aria-controls="nav-contact"
                  aria-selected="false"
                >
                  Shipping Methods
                </button>
                <button
                  className="nav-link"
                  id="nav-size-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-size"
                  type="button"
                  role="tab"
                  aria-controls="nav-size"
                  aria-selected="false"
                >
                  Size Chart
                </button>
              </div>
            </nav>

            <div className="tab-content" id="nav-tabContent">
              {/* Description Tab */}
              <div
                className="tab-pane fade show active"
                id="nav-home"
                role="tabpanel"
                aria-labelledby="nav-home-tab"
              >
                <h4 className="mt-3 mb-2">Product Description</h4>
                <p className="text-muted">
                  {props.productObj.description}{" "}
                  <span className="text-primary" style={{ cursor: "pointer" }}>
                    SHOW MORE
                  </span>
                </p>
              </div>

              {/* Reviews Tab */}
              <div
                className="tab-pane fade"
                id="nav-profile"
                role="tabpanel"
                aria-labelledby="nav-profile-tab"
              >
                <div className="mt-3">
                  <p className="mb-3">There are no reviews for this product.</p>
                  <h5 className="mb-3">Write a review</h5>
                  <form>
                    <div className="mb-3">
                      <label className="form-label">Your Name</label>
                      <input type="text" className="form-control" />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Your Review</label>
                      <textarea className="form-control" rows="4"></textarea>
                      <small className="form-text text-muted">
                        Note: HTML is not translated!
                      </small>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Rating</label>
                      <div className="d-flex gap-1">
                        <span>Bad</span>
                        <input type="radio" name="rating" value="1" />
                        <input type="radio" name="rating" value="2" />
                        <input type="radio" name="rating" value="3" />
                        <input type="radio" name="rating" value="4" />
                        <input type="radio" name="rating" value="5" />
                        <span>Good</span>
                      </div>
                    </div>
                    <button type="submit" className="btn btn-danger">
                      Submit Review
                    </button>
                  </form>
                </div>
              </div>

              {/* Shipping Methods Tab */}
              <div
                className="tab-pane fade"
                id="nav-contact"
                role="tabpanel"
                aria-labelledby="nav-contact-tab"
              >
                <div className="mt-3">
                  <p>
                    When you order from opencartworks.com, you will receive a
                    confirmation email. Once your order is shipped, you will be
                    emailed the tracking information for your order's shipment. You
                    can choose your preferred shipping method on the Order
                    Information page during the checkout process. The total time it
                    takes to receive your order is shown below:
                  </p>
                  <img className="img-fluid w-100 my-3" src={review} alt="Shipping timeline" />
                  <p>
                    The total delivery time is calculated from the time your order
                    is placed until the time it is delivered to you. Total delivery
                    time is broken down into processing time and shipping time.
                  </p>
                  <p>
                    <strong>Processing time:</strong> The time it takes to prepare your item(s) to
                    ship from our warehouse. This includes preparing your items,
                    performing quality checks, and packing for shipment.
                  </p>
                  <p>
                    <strong>Shipping time:</strong> The time for your item(s) to travel from our warehouse to
                    your destination. Shipping from your local warehouse is
                    significantly faster. Some charges may apply. In addition, the
                    transit time depends on where you're located and where your
                    package comes from. If you want to know more information, please
                    contact the customer service. We will settle your problem as
                    soon as possible. Enjoy shopping!
                  </p>
                </div>
              </div>

              {/* Size Chart Tab */}
              <div
                className="tab-pane fade"
                id="nav-size"
                role="tabpanel"
                aria-labelledby="nav-size-tab"
              >
                <div className="mt-3">
                  <img className="img-fluid w-100" src={sizeChart} alt="Size chart" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    cartItems: state.cart,
    isAuthenticated: state.auth.token !== null,
  };
};

const mapDispatchToProps = {
  addToCart: cartOperations.addToCart,
  showAddToCartModal: globalOperations.showAddToCartModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductBannerCard);